import { DiscountType } from '@spike/promocode-model';

export const INVALID_PROMOCODE_MESSAGE = 'Invalid promo code. Check code and try again.';
export const PROMO_CODE_MAX_LENGTH = 35;

export const toMoney = (value: string | number | null | undefined): number => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
};

export const roundMoney = (value: number): number => Math.round(value * 100) / 100;

export const resolveBookingDeposit = (
    apiDeposit: string | number | null | undefined,
    invoiceUnpaid: string | number | null | undefined,
    invoiceTotal: string | number | null | undefined,
    clientDeposit: number
): number => {
    const fromApi = toMoney(apiDeposit);
    if (fromApi > 0) {
        return fromApi;
    }

    const unpaid = toMoney(invoiceUnpaid);
    if (unpaid > 0) {
        return unpaid;
    }

    const fromInvoice = toMoney(invoiceTotal);
    if (fromInvoice > 0) {
        return fromInvoice;
    }

    return clientDeposit;
};

export const estimatePromocodeDiscount = (
    subtotal: number,
    discountType: DiscountType,
    discountValue: string
): number => {
    const value = toMoney(discountValue);

    if (discountType === DiscountType.PERCENTAGE) {
        return roundMoney(subtotal * (value / 100));
    }

    return Math.min(value, subtotal);
};
